(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vital-pet-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.vp');
  if (!root) return;
  var loading = root.querySelector('[data-vp-cart-loading]');

  function showLoading() { if (loading) loading.classList.add('is-active'); }

  function changeLine(line, quantity) {
    showLoading();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      window.location.reload();
    })
    .catch(function () {
      window.location.reload();
    });
  }

  // − / + / remove buttons
  root.querySelectorAll('[data-vp-cart-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(btn.getAttribute('data-vp-cart-minus'), 10);
      var qEl = root.querySelector('[data-vp-cart-q="' + line + '"]');
      var current = qEl ? parseInt(qEl.textContent, 10) : 1;
      changeLine(line, Math.max(0, current - 1));
    });
  });
  root.querySelectorAll('[data-vp-cart-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(btn.getAttribute('data-vp-cart-plus'), 10);
      var qEl = root.querySelector('[data-vp-cart-q="' + line + '"]');
      var current = qEl ? parseInt(qEl.textContent, 10) : 1;
      changeLine(line, current + 1);
    });
  });
  root.querySelectorAll('[data-vp-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(btn.getAttribute('data-vp-cart-remove'), 10);
      changeLine(line, 0);
    });
  });

  // Upsell — submit form via AJAX so we don't leave the cart page
  root.querySelectorAll('[data-vp-cart-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      showLoading();
      var data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data
      })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vital-pet-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.vp');
  if (!root) return;

  root.querySelectorAll('[data-vp-scroll]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var href = el.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  var slides = root.querySelectorAll('[data-vp-review-slide]');
  var dots   = root.querySelectorAll('[data-vp-review]');
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var i = parseInt(dot.getAttribute('data-vp-review'), 10);
      slides.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
      dots.forEach(function (d, j)   { d.classList.toggle('is-active', i === j); });
    });
  });

  var pkgs = root.querySelectorAll('[data-vp-pkg]');
  var variantInput = root.querySelector('[data-vp-variant-input]');
  var ctaPrice = root.querySelector('[data-vp-cta-price]');
  var stickyPrice = root.querySelector('[data-vp-sticky-price]');
  var stickyName = root.querySelector('[data-vp-sticky-name]');

  pkgs.forEach(function (pkg) {
    pkg.addEventListener('click', function () {
      var input = pkg.querySelector('[data-vp-pkg-input]');
      if (!input) return;
      input.checked = true;
      pkgs.forEach(function (p) { p.classList.remove('is-active'); });
      pkg.classList.add('is-active');
      var variantId = input.getAttribute('data-variant-id');
      var price = input.getAttribute('data-price');
      var name  = input.getAttribute('data-name');
      if (variantInput && variantId) variantInput.value = variantId;
      if (ctaPrice && price)    ctaPrice.textContent    = price;
      if (stickyPrice && price) stickyPrice.textContent = price;
      if (stickyName && name)   stickyName.textContent  = name;
    });
  });

  var sticky = root.querySelector('[data-vp-sticky]');
  if (sticky) {
    var onScroll = function () {
      var v = window.scrollY > 600;
      sticky.classList.toggle('is-visible', v);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vital-pet-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.vp');
  if (!root) return;

  // Gallery thumbnail switching
  var thumbs = root.querySelectorAll('[data-vp-thumb]');
  var mainImg = root.querySelector('[data-vp-main] img');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-img');
      if (mainImg && src) mainImg.src = src;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // Quantity stepper
  var qtyInput = root.querySelector('[data-vp-qty-input]');
  var qtyMinus = root.querySelector('[data-vp-qty-minus]');
  var qtyPlus  = root.querySelector('[data-vp-qty-plus]');
  if (qtyInput) {
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.min(10, v + 1);
    });
  }

  // Review carousel
  var slides = root.querySelectorAll('[data-vp-review-slide]');
  var dots   = root.querySelectorAll('[data-vp-review]');
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var i = parseInt(dot.getAttribute('data-vp-review'), 10);
      slides.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
      dots.forEach(function (d, j)   { d.classList.toggle('is-active', i === j); });
    });
  });

  // Sticky CTA visibility
  var sticky = root.querySelector('[data-vp-sticky]');
  if (sticky) {
    var onScroll = function () {
      var v = window.scrollY > 700;
      sticky.classList.toggle('is-visible', v);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Sticky button submits the form
  var stickyBtn = root.querySelector('[data-vp-sticky-buy]');
  var form = root.querySelector('.vp-pdp-form');
  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
